<atn-ds-page>
  <atn-ds-table [config]="tableConfig" />
</atn-ds-page>
